import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';
import { consentDenied } from './consentDenied';
import { consentChanged } from './consentChanged';

export const consent: Maker<Ctx, Snap, boolean> = ({
  makeEffect,
  makeEffectGroup,
}) => [
  makeEffect(
    'initChangeTracking',
    (_, { ctx, cond }) =>
      cond(ctx.journal.utiq_consent_status === undefined, ''),
    (_, { ctx, snap }) =>
      (ctx.journal.utiq_consent_status = snap.cookies.utiq_consent_status),
  ),

  makeEffectGroup(
    'changed',
    (_, { ctx, snap, pass, skip }) =>
      ctx.journal.utiq_consent_status !== snap.cookies.utiq_consent_status
        ? pass(null)
        : skip(''),
    consentChanged,
  ),

  makeEffectGroup(
    'denied',
    (_, { snap, pass, skip }) =>
      snap.cookies.utiq_consent_status === 'false' ? pass(null) : skip(''),
    consentDenied,
  ),

  makeEffect(
    'updateChangeTracking',
    (_, { ctx, snap, cond }) =>
      cond(
        ctx.journal.utiq_consent_status !== snap.cookies.utiq_consent_status,
        '',
      ),
    (_, { ctx, snap }) => {
      ctx.journal.utiq_consent_status = snap.cookies.utiq_consent_status;
    },
  ),
];
